export default __webpack_public_path__ + "static/media/newspaper-magazine-outline-16px.4d48c9d8.svg";